<template>
    <div>
        <v-text-field
            autocomplete="off"
            label="Search"
            prepend-icon="mdi-magnify"
            dense
            style="margin-left: 15px; margin-right: 15px; margin-top: 25px; margin-bottom: -15px;"
            ref="search"
            v-model="full_text"
            @keydown.enter="onClickFirstRow"
        >
        </v-text-field>

        <v-list dense>

            <template v-for="(item, index) in menu_items">
                <!-- Regular item -->
                <v-list-item
                    v-if="!item.admin_only"
                    :key="'menu_item_' + index"
                    v-on:click="onClickMenuItem($event, item)"
                    v-on:contextmenu.prevent="onRightClick($event, item)"
                    link
                >
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.text }}
                            <v-icon
                                v-if="isPinned(item)"
                                small
                                color="primary"
                                class="ml-1"
                                style="float: right;"
                            >mdi-pin</v-icon>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Admin-only item -->
                <m-restricted-menu-list-item
                    v-else-if="$rc.$state.isAuthActorSystemAdmin()"
                    :key="'admin_menu_item_' + index"
                    v-on:click="$rc.$state.isAuthActorSystemAdmin() ? onClickMenuItem($event, item) : null"
                    v-on:contextmenu.prevent="$rc.$state.isAuthActorSystemAdmin() ? onRightClick($event, item) : null"
                    :text="item.text"
                    :pinned="isPinned(item)"
                    :icon="item.icon"
                />
            </template>

        </v-list>

        <!-- Context Menu -->
        <v-menu
            v-model="show_context_menu"
            :position-x="context_menu_x"
            :position-y="context_menu_y"
            absolute
            offset-y
        >
            <v-list>
                <v-list-item @click="togglePin(context_menu_item)">
                    <v-list-item-title>
                        {{ isPinned(context_menu_item) ? 'Unpin' : 'Pin' }}
                        <v-icon
                            small
                            class="ml-2"
                            style="float: right;"
                        >{{ isPinned(context_menu_item) ? 'mdi-pin-off' :
                            'mdi-pin' }}</v-icon>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: function () { return false; }
        },
    },

    data() {
        return {
            full_text: null,
            pinned_items: [],
            show_context_menu: false,
            context_menu_x: 0,
            context_menu_y: 0,
            context_menu_item: null,
        }
    },

    created() {
        this.loadPinnedItems();
    },


    methods: {
        onRightClick(event, item) {
            this.context_menu_x = event.clientX;
            this.context_menu_y = event.clientY;
            this.context_menu_item = item;
            this.show_context_menu = true;
        },

        getItemId(item) {
            // Create a unique identifier for the menu item
            let id = item.text;
            if (item.page) {
                id += '_' + item.page;
            }
            if (item.query) {
                id += '_' + JSON.stringify(item.query);
            }
            return id;
        },

        isPinned(item) {
            if (!item) return false;
            const itemId = this.getItemId(item);
            return this.pinned_items.includes(itemId);
        },

        togglePin(item) {
            if (!item) return;

            const itemId = this.getItemId(item);
            const index = this.pinned_items.indexOf(itemId);

            if (index === -1) {
                // Pin the item
                this.pinned_items.push(itemId);
            } else {
                // Unpin the item
                this.pinned_items.splice(index, 1);
            }

            this.savePinnedItems();
        },

        getPinnedItemsStorageKey() {
            // Get the auth actor's employee ID to create a user-specific storage key
            const auth_employee_id = this.$rc.$state.getAuthActorEmployeeId();
            return auth_employee_id ? `pinned_menu_items_${auth_employee_id}` : 'pinned_menu_items';
        },

        loadPinnedItems() {
            const LocalStorage = require('../../js/LocalStorage.js');
            const storage = new LocalStorage();
            const storage_key = this.getPinnedItemsStorageKey();
            const saved_items = storage.get(storage_key, []);
            this.pinned_items = saved_items;
        },

        savePinnedItems() {
            const LocalStorage = require('../../js/LocalStorage.js');
            const storage = new LocalStorage();
            const storage_key = this.getPinnedItemsStorageKey();
            storage.set(storage_key, this.pinned_items);
        },

        onUpdateDrawer(value) {
            if (value) {
                window.setTimeout(
                    () => {
                        this.$refs['drawer-search'].focus();
                    },
                    100
                );
            }
        },

        onClickFirstRow() {
            if (this.menu_items.length == 0)
                return;

            this.onClickMenuItem({}, this.menu_items[0]);
        },

        onClickMenuItem(event, item) {
            if (item.page != null) {
                this.quietPush(item, event);
                return;
            }

            item.on_click();
        },

        quietPush(item, event) {
            this.closeDrawer();

            event = this.$rc.cloneEvent(event);

            if (item.link_out) {
                event.ctrlKey = true;
            }

            let route = {
                'name': item.page,
                'params': {
                    'employee_id': this.$rc.$state.employee_id,
                    'organization_id': this.$rc.$state.organization_id,
                },
                'query': item.query,
            };

            this.$rc.navigationClick(this.$router, route, event);
        },

        onClickHome() {
            this.quietPush({ 'page': 'home' });
        },

        onClickSignOut() {
            if (this.$rc.$state.offerSignOutReturnToAdminAccount()) {
                // Sign back in as the system administrator account
                this.signInAsSystemAdminAccount();
                return;
            }

            this.closeDrawer();

            if (this.$rc.$state.isAuthActorSystemAdmin()) {
                this.confirmSystemAdminSignout();
                return;
            }

            this.doSignOut();
        },

        signInAsSystemAdminAccount() {
            this.$rc.signInAsAuthAccount(
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.next_page_snackbar('You are now signed in as ' + this.$rc.$state.getAuthActorUsername(), 3000);

                    this.$router.push({
                        'name': 'home',
                    }).catch(e => { }); // swallow any exception
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error', 'Unable to complete API call');
                },
            );
        },

        confirmSystemAdminSignout() {
            this.$rc.confirm({
                'title': 'System Administrator Sign Out',
                'body': 'You are about to sign out from your system administrator account.  Are you <b>absolutely sure</b> that you want to do this?',
                'btn_text_ok': 'Sign Out',
                'btn_text_cancel': 'Cancel',
                'text_to_confirm_message': 'To sign out, type "confirm" below.',
                'text_to_confirm': 'confirm',
                'on_ok': () => {
                    this.doSignOut();
                },
            });
        },

        closeDrawer() {
            this.$emit('input', false);
        },

        doSignOut() {
            const domain = this.$rc.$state.getEffectiveAuth0Domain?.();
            const client_id = this.$rc.$state.getEffectiveAuth0ClientId?.();
            const return_to = window.location.origin + '/app/sign-in';

            this.$rc.signOut();

            if (domain && client_id) {
                const url = `https://${domain}/v2/logout?client_id=${encodeURIComponent(client_id)}&returnTo=${encodeURIComponent(return_to)}`;
                window.location.href = url;
                return;
            }

            this.$router.push({
                'name': 'sign-in',
                'params': {
                }
            });
        },

        onClickCRM(content_type) {
            this.closeDrawer();

            this.$router.push({
                'name': 'crm-home',
                'params': {
                    'organization_id': this.$rc.$state.organization_id,
                    'content_type': content_type
                }
            }).catch(e => { }); // swallow any exception
        },

        fullTextFilter(full_text, item) {
            full_text = (full_text ?? '').trim().toLowerCase();

            // If no search text is entered
            if (full_text.length == 0) {
                // Always include pinned items, regardless of search_only status
                if (this.isPinned(item)) {
                    return true;
                }
                // For non-pinned items, follow the original logic
                return !(item.search_only ?? false);
            }

            // When search text is entered, apply search filter to all items including pinned ones
            let tokens = full_text.split(/(\s+)/);
            tokens = tokens.filter((token) => token.trim().length > 0);

            return tokens.every((token) => this.itemText(item).toLowerCase().includes(token));
        },

        itemText(item) {
            let ret = item.text;

            if (item.alt_text != null) {
                ret += ' ' + item.alt_text;
            }

            return ret;
        },

        onClickAdmin(route) {
            route.params = route.params ?? {};
            route.params.employee_id = route.params.employee_id ?? this.$rc.$state.employee_id;
            route.params.organization_id = route.params.organization_id ?? this.$rc.$state.organization_id;

            if (this.$rc.$state.isSystemAdmin()) {
                this.$router.push(route);
            }
            else {
                this.$rc.newSignInAsAuthAccount({ 'after_route': route });
            }
        },
    },

    computed: {
        menu_items() {
            let ret = [];

            if (this.$rc.$state.getOrganizationSpecialPurpose()) {
                ret.push({ 'text': 'Home', 'icon': 'mdi-home', 'on_click': this.onClickHome });
                ret.push({ 'text': 'Sign Out', 'icon': 'mdi-logout', 'on_click': this.onClickSignOut });

                return ret;
            }

            ret.push({ 'text': 'Home', 'icon': 'mdi-home', 'on_click': this.onClickHome });
            ret.push({ 'text': 'Account Settings', 'icon': 'mdi-cog', 'page': 'settings-account' });
            ret.push({ 'text': 'Organization Settings', 'icon': 'mdi-domain', 'page': 'settings-organization' });
            ret.push({ 'text': 'Contacts', 'icon': 'mdi-contacts', 'page': 'fulltext-search-contacts' });
            ret.push({ 'text': 'Lists', 'icon': 'mdi-format-list-bulleted-square', 'page': 'search-lists' });
            ret.push({ 'text': 'Contact Requests', 'icon': 'mdi-card-account-mail', 'page': 'search-open-contact-requests' });
            ret.push({ 'text': 'Web Chat Requests', 'icon': 'mdi-web', 'page': 'search-inbox-contact-requests-without-start-inbox' });
            ret.push({ 'text': 'Consent Register', 'icon': 'mdi-account-group', 'page': 'search-consent-register' });

            if (this.$rc.$state.showBulkMessages()) {
                ret.push({ 'text': 'Bulk Messages', 'icon': 'mdi-comment-text-multiple', 'page': 'search-bulk-messages' });
            }

            ret.push({ 'text': 'Saved Messages', 'icon': 'mdi-message-draw', 'page': 'search-saved-messages' });
            ret.push({ 'text': 'Payments', 'icon': 'mdi-cash-multiple', 'page': 'search-payments' });
            ret.push({ 'text': 'Schedule', 'icon': 'mdi-watch', 'page': 'settings-organization-schedule' });

            // All of the CRM links...
            for (let i = 0; i < this.active_crms.length; i++) {
                let crm = this.active_crms[i];

                ret.push({ 'text': crm.text, 'icon': 'mdi-vector-link', 'on_click': () => { this.onClickCRM(crm.value) } });
            }

            if (this.$rc.$state.isFINRAEnabled() && this.$rc.$state.isOrganizationAdmin()) {
                ret.push({ 'text': 'Compliance', 'icon': 'mdi-cloud-upload-outline', 'page': 'compliance-all' });
            }

            ret.push({ 'text': 'Automated Messages', 'icon': 'mdi-robot', 'page': 'auto-messages-home' });

            //Admin only items
            // be sure to add admin_only: true to any item that should only be visible to admins
            {
                ret.push({ 'text': 'Test > Expired Magic Link', 'icon': 'mdi-link', 'search_only': true, 'page': 'public-magic-link-expired', 'admin_only': true });

                ret.push({ 'text': 'Tests', 'icon': 'mdi-xml', 'search_only': true, 'on_click': () => { this.onClickAdmin({ name: 'all-tests' }); }, 'admin_only': true });
                ret.push({ 'text': 'Test > Input', 'icon': 'mdi-xml', 'search_only': true, 'on_click': () => { this.onClickAdmin({ name: 'test-input' }); }, 'admin_only': true });


                ret.push({ 'text': 'Admin', 'icon': 'mdi-lock-check', 'on_click': () => { this.onClickAdmin({ name: 'all-admin' }); }, 'admin_only': true });
                ret.push({ 'text': 'Demos', 'icon': 'mdi-presentation', 'page': 'demo-selector'});
                ret.push({ 'text': 'Admin > Cron', 'icon': 'mdi-code-less-than-or-equal', 'page': 'admin-processors', 'search_only': true, 'admin_only': true });
                ret.push({ 'text': 'Admin > Organization Billing Settings', 'icon': 'mdi-invoice-list-outline', 'page': 'admin-billing-one-organization', 'search_only': true, 'admin_only': true });
                ret.push({ 'text': 'Admin > Provision', 'icon': 'mdi-cloud-sync-outline', 'page': 'provision', 'search_only': true, 'admin_only': true });
                ret.push({ 'text': 'Admin > Provision New Organization', 'alt_text': 'Create Organization', 'icon': 'mdi-cloud-plus-outline', 'on_click': () => { this.onClickAdmin({ name: 'admin-create-organization', params: { organization_id: this.$rc.uuidv4() } }); }, 'search_only': true, 'admin_only': true });
                ret.push({ 'text': 'Admin > Rate Card', 'icon': 'mdi-invoice-list-outline', 'page': 'edit-organization-rate-card', 'search_only': true, 'admin_only': true });
                ret.push({ 'text': 'Admin > RedChirp CRM Notes', 'icon': 'mdi-note-multiple-outline', 'page': 'rc-crm-view-organization', 'search_only': true, 'admin_only': true });
                ret.push({ 'text': 'Admin > TCR Campaign Registration', 'icon': 'mdi-human-greeting', 'page': 'welcome_admin_tcr_campaign_registration', 'search_only': true, 'admin_only': true });
                ret.push({ 'text': 'Admin > Password Reset Requests', 'icon': 'mdi-lock-reset', 'page': 'admin-password-reset-links', 'search_only': true, 'admin_only': true });

                ret.push({ 'text': 'Alert Delivery Settings', 'icon': 'mdi-cog', 'page': 'alert-delivery-preferences', 'search_only': true, 'admin_only': true });


                ret.push({ 'text': 'Test Timeline', 'icon': 'mdi-code-less-than-or-equal', 'page': 'test-timeline', 'search_only': true, 'admin_only': true });

                ret.push({ 'text': 'Settings > Lightboxes', 'icon': 'mdi-cog', 'page': 'lightbox-search-settings', 'search_only': true });
                ret.push({ 'text': 'Settings > Lightbox URL(s)', 'icon': 'mdi-cog', 'page': 'lightbox-urls', 'search_only': true });
                ret.push({ 'text': 'Lightbox Submissions', 'icon': 'mdi-form-textbox', 'page': 'lightbox-submissions', 'search_only': false });

                ret.push({ 'text': 'Settings > Guest Check In', 'icon': 'mdi-clipboard-check-outline', 'page': 'search-forms-guest-check-in', 'search_only': true });
                ret.push({ 'text': 'Guest Check In Submissions', 'icon': 'mdi-clipboard-list', 'page': 'guest-check-in-submissions', 'search_only': false });
                ret.push({ 'text': 'Guest Check In Analytics', 'icon': 'mdi-chart-line', 'page': 'guest-check-in-analytics', 'search_only': true });
                ret.push({ 'text': 'Settings > Order Confirmation Forms', 'icon': 'mdi-check-circle-outline', 'page': 'search-forms-order-confirmation', 'search_only': true});
                ret.push({ 'text': 'Order Confirmation Entries', 'icon': 'mdi-store-check', 'page': 'order-confirmation-submissions', 'search_only': false});
                ret.push({ 'text': 'Order Confirmation Analytics', 'icon': 'mdi-chart-box-outline', 'page': 'order-confirmation-analytics', 'search_only': true});

                ret.push({
                    'text': 'Admin > Bulk Message Templates', 'icon': 'mdi-cog', 'on_click': () => {

                        this.$router.push({
                            'name': 'admin-bulk-message-templates',
                            'params': {
                                'organization_id': this.$rc.$state.organization_id,
                            },
                            'query': {
                                'admin': true,
                            },
                        });

                    }, 'search_only': true, 'admin_only': true
                });
            }

            ret.push({ 'text': 'Analytics', 'icon': 'mdi-google-analytics', 'page': 'all-analytics' });

            ret.push({ 'text': 'Help & Tutorials', 'icon': 'mdi-help-box-multiple-outline', 'page': 'help' });
            ret.push({ 'text': 'Sign Out', 'icon': 'mdi-logout', 'on_click': this.onClickSignOut });

            // These are all of the menu items that only show when searched...
            {
                ret.push({ 'text': 'Account Change Log', 'icon': 'mdi-format-list-bulleted-square', 'page': 'account-change-log', 'search_only': true });
                ret.push({ 'text': 'Account Access Log', 'icon': 'mdi-format-list-bulleted-square', 'page': 'account-access-log', 'search_only': true });

                ret.push({ 'text': 'Default Messaging Opt In Form', 'icon': 'mdi-form-select', 'page': 'default-opt-in-form', 'search_only': true, 'link_out': true });
                ret.push({ 'text': 'Toll Free Messaging Opt In Form', 'icon': 'mdi-form-select', 'page': 'toll-free-opt-in-form', 'search_only': true, 'link_out': true });

                ret.push({ 'text': 'Events', 'icon': 'mdi-code-less-than-or-equal', 'page': 'events', 'search_only': true });
                ret.push({ 'text': 'Shipping Events (Second Generation)', 'icon': 'mdi-truck', 'page': 'events', query: { 'initial-event-types': 'second-generation-shipping-events' }, 'search_only': true });

                ret.push({ 'text': 'Welcome Screen', 'icon': 'mdi-human-greeting', 'page': 'welcome_ordinary_user', 'search_only': true, query: { 'origin': 'nav' } });

                ret.push({ 'text': 'Vendor Assesment Center', 'icon': 'mdi-open-in-new', 'page': 'https://redchirp.com/vendor-assessment-resource-center', 'search_only': true, 'link_out': true });

                ret.push({ 'text': 'Analytics > Bulk Messages', 'icon': 'mdi-google-analytics', 'page': 'analytics-all-bulk-messages', 'search_only': true });
                ret.push({ 'text': 'Analytics > Keyword Auto Responses', 'icon': 'mdi-google-analytics', 'page': 'reporting-keyword-auto-response', 'search_only': true });
                ret.push({ 'text': 'Analytics > Phone Number Validation', 'icon': 'mdi-google-analytics', 'page': 'search-endpoint-validation-details', 'search_only': true });
                ret.push({ 'text': 'Analytics > Web Chat Requests', 'icon': 'mdi-google-analytics', 'page': 'analytics-web-chat', 'search_only': true });
                ret.push({ 'text': 'Contacts > Import Contacts', 'alt_text': 'Contact Imports', 'icon': 'mdi-file-import', 'page': 'contact-import-search', 'search_only': true });
                ret.push({ 'text': 'Lists > Import to List', 'alt_text': 'Contact List Imports', 'icon': 'mdi-file-import', 'page': 'search-contact-list-imports', 'search_only': true });
                ret.push({ 'text': 'Bulk Messages > Import Recipients', 'alt_text': 'Import Bulk Message Recipients', 'icon': 'mdi-file-import', 'page': 'search-bulk-message-recipient-imports', 'search_only': true });


                ret.push({ 'text': 'Sign In As', 'icon': 'mdi-clipboard-account-outline', 'on_click': () => { this.$emit('sign-in-as'); }, 'search_only': true });

                ret.push({ 'text': 'Settings > API Keys', 'icon': 'mdi-cog', 'page': 'settings-organization-api-keys', 'search_only': true });
                ret.push({ 'text': 'Settings > API Keys > API Call Log', 'icon': 'mdi-cog', 'page': 'settings-organization-api-call-log', 'search_only': true });
                ret.push({ 'text': 'Settings > Blocked (Spam) Numbers', 'icon': 'mdi-cog', 'page': 'settings-organization-spam-numbers', 'search_only': true });
                ret.push({ 'text': 'Settings > Branded Link Shortener', 'icon': 'mdi-cog', 'page': 'settings-organization-branded-link-shortener', 'search_only': true });
                ret.push({ 'text': 'Settings > Custom Keywords', 'icon': 'mdi-cog', 'page': 'settings-organization-keyword-auto-responses', 'search_only': true });
                ret.push({ 'text': 'Settings > CTIA Keywords', 'icon': 'mdi-cog', 'page': 'settings-organization-ctia-keyword-auto-responses', 'search_only': true });
                ret.push({ 'text': 'Settings > Forms', 'icon': 'mdi-cog', 'page': 'search-forms', 'search_only': true });
                ret.push({ 'text': 'Settings > Inboxes', 'icon': 'mdi-cog', 'page': 'edit-inboxes', 'search_only': true });
                ret.push({ 'text': 'Settings > Introductions', 'icon': 'mdi-cog', 'page': 'settings-organization-introductions', 'search_only': true });
                ret.push({ 'text': 'Settings > Order Attribution', 'icon': 'mdi-cog', 'page': 'settings-organization-order-attribution', 'search_only': true });
                ret.push({ 'text': 'Settings > RedChirp Billing', 'icon': 'mdi-cog', 'page': 'organization-redchirp-billing-settings', 'search_only': true });
                ret.push({ 'text': 'Settings > RedChirp Tags', 'icon': 'mdi-cog', 'page': 'settings-organization-tags', 'search_only': true });
                ret.push({ 'text': 'Settings > Webchat Widget', 'icon': 'mdi-cog', 'page': 'settings-organization-widget', 'search_only': true });
                ret.push({ 'text': 'Settings > Custom Consent Agreements', 'icon': 'mdi-cog', 'page': 'settings-custom-consent-agreements', 'search_only': true });
                ret.push({ 'text': 'Consent Register > Import Consent', 'icon': 'mdi-file-import', 'page': 'search-consent-imports', 'search_only': true });

                ret.push({ 'text': 'Bulk Message Templates', 'icon': 'mdi-comment-text-multiple', 'page': 'bulk-message-template-create-page', 'search_only': true });
                ret.push({ 'text': 'Developer > My Apps', 'icon': 'mdi-code-less-than-or-equal', 'page': 'developer-search-my-apps', 'search_only': true });
                ret.push({ 'text': 'RedChirp App Store', 'icon': 'mdi-application-brackets-outline', 'page': 'app-search', 'search_only': true });
                ret.push({ 'text': 'Shipping Events Held in Abeyance', 'icon': 'mdi-truck-delivery', 'page': 'shipping-events-held-in-abeyance', 'search_only': true });

                ret.push({ 'text': 'Settings > Fonts', 'icon': 'mdi-format-font', 'page': 'settings-organization-fonts', 'search_only': true });
                ret.push({ 'text': 'Accessibility', 'icon': 'mdi-human', 'page': 'accessibility', 'search_only': true });

                ret.push({ 'text': 'RedChirp Updated Agreements for 2026 Announcement', 'icon': 'mdi-scale-balance', 'page': 'public-updated-agreements-2026-announcement', 'search_only': true }); 
            }


            // Filter items based on search text
            ret = ret.filter((item) => this.fullTextFilter(this.full_text, item));

            // First, separate pinned and non-pinned items

            const pinned_items = ret.filter(item => this.isPinned(item));
            const non_pinned_items = ret.filter(item => !this.isPinned(item));

            // Sort pinned items alphabetically by text
            pinned_items.sort((a, b) => {
                return a.text.localeCompare(b.text);
            });

            // Return the combined array with sorted pinned items at the top
            ret = [...pinned_items, ...non_pinned_items];

            return ret;
        },


        active_crms() {
            let raw = this.$rc.enumChoices('integration_name', false);
            let ret = [];

            for (let i = 0; i < raw.length; i++) {
                let cur = raw[i];

                if (cur.value == 'redchirp') continue;
                if (cur.value == 'fare-harbor') continue;
                if (cur.value == 'mailchimp') continue;
                if (cur.value == 'klaviyo') continue;
                if (cur.value == 'wine-shipping') continue;
                if (cur.value == 'calendly') continue;

                if (!this.$rc.$state.isCRMEnabled(cur.value)) continue;

                ret.push(cur);
            }

            return ret;
        },
    },

    watch: {
        value(new_value, old_value) {

            if (new_value) {
                this.full_text = null;
                window.setTimeout(
                    () => {
                        this.$refs['search'].focus();
                    },
                    100
                );
            }
        }
    },
}
</script>

<style lang="scss" scoped></style>